import * as type from '../types/single-client'

export const retrieveSingleClientDetails = payload => {
    return{
        type: type.REQUEST_SINGLE_CLIENT_DETAILS,
        payload: payload
    }
}

export const resetSingleClientDetails = () => {
    return{
        type: type.RESET_SINGLE_CLIENT_DETAILS
    }
}

export const retrieveSingleClientRoles = payload => {
    return{
        type: type.REQUEST_SINGLE_CLIENT_ROLES,
        payload: payload
    }
}

export const resetSingleClientRoles = () => {
    return{
        type: type.RESET_SINGLE_CLIENT_ROLES
    }
}

export const retrieveSingleClientSales = payload => {
    return{
        type: type.REQUEST_SINGLE_CLIENT_SALES,
        payload: payload
    }
}

export const resetSingleClientSales = () => {
    return{
        type: type.RESET_SINGLE_CLIENT_SALES
    }
}

export const retrieveSingleClientNotes = payload => {
    return{
        type: type.REQUEST_SINGLE_CLIENT_NOTES,
        payload: payload
    }
}

export const resetSingleClientNotes = () => {
    return{
        type: type.RESET_SINGLE_CLIENT_NOTES
    }
}

export const changeSingleClientModal = payload => {
    return{
        type: type.CHANGE_SINGLE_CLIENT_MODAL,
        modal: payload
    }
}

export const changeSingleClientSalesYear = payload => {
    return{
        type: type.CHANGE_SINGLE_CLIENT_SALES_YEAR,
        year: payload
    }
}

export const requestAddSingleClientSale = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_CLIENT_SALE,
        payload: payload
    }
}

export const resetAddSingleClientSale = () => {
    return{
        type: type.RESET_ADD_SINGLE_CLIENT_SALE,
    }
}

export const requestUpdateSingleClientData = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_CLIENT_DATA,
        details: payload
    }
}

export const resetUpdateSingleClientData = () => {
    return{
        type: type.RESET_UPDATE_SINGLE_CLIENT_DATA
    }
}

export const requestDeleteSingleClientData = payload => {
    return{
        type: type.REQUEST_REMOVE_SINGLE_CLIENT_DATA,
        details: payload
    }
}

export const resetDeleteSingleClientData = () => {
    return{
        type: type.RESET_REMOVE_SINGLE_CLIENT_DATA
    }
}

export const setSingleClientActiveSalesKey = payload => {
    return{
        type: type.SET_SINGLE_CLIENT_ACTIVE_SALES_KEY,
        key: payload
    }
}

export const resetSingleClientActiveSalesKey = () => {
    return{
        type: type.RESET_SINGLE_CLIENT_ACTIVE_SALES_KEY
    }
}

export const requestUpdateSingleClientSale = payload => {
    return{
        type: type.REQUEST_UPDATE_SINGLE_CLIENT_SALE,
        details: payload
    }
}

export const resetUpdateSingleClientSale = () => {
    return{
        type: type.RESET_UPDATE_SINGLE_CLIENT_SALE
    }
}

export const requestDeleteSingleClientSale = payload => {
    return{
        type: type.REQUEST_REMOVE_SINGLE_CLIENT_SALE,
        details: payload
    }
}

export const resetDeleteSingleClientSale = () => {
    return{
        type: type.RESET_REMOVE_SINGLE_CLIENT_SALE
    }
}

export const setSingleClientActiveSale = payload => {
    return{
        type: type.SET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY,
        details: payload
    }
}

export const resetSingleClientActiveSale = () => {
    return{
        type: type.RESET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY
    }
}

export const requestAddSingleClientNote = payload => {
    return{
        type: type.REQUEST_ADD_SINGLE_CLIENT_NOTE,
        details: payload
    }
}

export const resetAddSingleClientNote = () => {
    return{
        type: type.RESET_ADD_SINGLE_CLIENT_NOTE
    }
}

export const requestDeleteSingleClientNote = payload => {
    return{
        type: type.REQUEST_REMOVE_SINGLE_CLIENT_NOTE,
        details: payload
    }
}

export const resetDeleteSingleClientNote = () => {
    return{
        type: type.RESET_REMOVE_SINGLE_CLIENT_NOTE
    }
}

/** */

export const retrieveSelectionYears = payload => {
    return{
        type: type.REQUEST_SELECTION_YEARS,
        payload: payload
    }
}

export const resetSelectionYears = () => {
    return{
        type: type.RESET_SELECTION_YEARS
    }
}

export const setActiveSelectionYear = payload => {
    return{
        type: type.SET_ACTIVE_SELECTION_YEAR,
        year: payload
    }
}

export const resetActiveSelectionYear = () => {
    return{
        type: type.RESET_ACTIVE_SELECTION_YEAR
    }
}
